<template>
  <div class="list-item">
    <img class="top-img" :src="pic" v-if="pic" alt="" />

    <NewsCard
      v-for="(item, index) in list"
      :key="index"
      :item="item"
      @click="goToDetail(item)"
    />

    <EmptyState v-if="list.length === 0" />

    <van-pagination
      v-if="list.length > 0"
      @change="handlePageChange()"
      v-model="currentPage"
      :total-items="total"
      :show-page-size="3"
      force-ellipses
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { Pagination } from 'vant';
import NewsCard from "@/components/NewsCard.vue";
import EmptyState from "@/components/EmptyState.vue";
Vue.use(Pagination);
import { get } from "@/request/http";
export default {
  components: {
    NewsCard,
    EmptyState,
  },
  data() {
    return {
      list: [],
      limit: 8,
      currentPage: 1,
      total: 0,
      page: 1,
      title:'',
      pic: "",
      categoryId: "",
    };
  },
  // 监听 title变化
  watch: {
    title(newVal) {
      document.title = newVal;
    },
  },
  // 页面离开
  deactivated() {
    this.pic = "";
    this.title = "";
    this.categoryId = "";
    this.list = [];
  },
  activated() {
    this.list = [];
    this.$route.query.title &&
    (this.title = decodeURIComponent(this.$route.query.title));
    if (this.title) {
      document.title = this.title;
    }
    this.$route.query.ztIMG &&
      (this.pic = decodeURIComponent(this.$route.query.ztIMG));
    this.$route.query.categoryId &&
      (this.categoryId = this.$route.query.categoryId);
    this.fetchNewsList(this.categoryId);
  },
  methods: {
    // 分页变化
    handlePageChange() {
      this.page = this.currentPage;
      this.fetchNewsList(this.categoryId);
    },
    // 加载当前分类的新闻列表
    fetchNewsList(categoryId) {
      if(this.pic){
        this.limit = 6
      }else {
        this.limit = 8
      }
      get(
        `/gbs/portal/portal/specialColumnNewsPage?limit=${this.limit}&page=${this.page}&categoryId=${categoryId}&title=`
      ).then((res) => {
        if (res.code !== 0) {
          this.$Toast.fail(res.msg);
          return;
        }
        this.total = res.data.total || 0;
        this.list = res.data.list || res.data;
      });
    },
    /**
     * 跳转详情页
     * @param {Object} item - 新闻项对象
     * info_type: 0-图文, 1-视频, 2-音频, 3-跳转, 4-文件, 5-附件
     */
    goToDetail(item) {
      if (
        item.info_type === 0 ||
        item.info_type === 1 ||
        item.info_type === 2 ||
        item.info_type === 4
      ) {
        // 图文、视频、音频、文件类型，跳转到详情页
        this.$router.push({
          path: "/detail",
          query: {
            newsId: item.id,
          },
        });
      } else if (item.info_type === 3) {
        // 跳转类型，打开外部链接
        window.open(item.jump_url);
      } else if (item.info_type === 5) {
        // 附件类型，打开附件
        window.open(item.attachment);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/variable.scss";

.list-item {
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 120px;
  box-sizing: border-box;

  ::v-deep .van-pagination {
    position: fixed;
    bottom: calc(20px + constant(safe-area-inset-bottom));
    bottom: calc(20px + env(safe-area-inset-bottom));
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    margin-top: 20px;
    text-align: center;

    .van-pagination__item {
      color: $color-primary-text;
    }

    .van-pagination__item--active {
      background-color: $color-primary-text;
      color: #fff;
    }

    .van-pagination__item:active {
      background-color: $color-primary-text;
      color: #fff;
    }
  }

  .top-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
}
</style>
